
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M8.1 13.34L10.93 10.51L4.74 4.32999C4.26 3.84999 3.43 3.97999 3.13 4.59999C2.42 6.08999 2.68 7.91999 3.91 9.15999L8.1 13.34ZM14.88 11.53C16.41 12.24 18.56 11.74 20.15 10.15C22.06 8.23999 22.43 5.49999 20.96 4.02999C19.5 2.56999 16.76 2.92999 14.84 4.83999C13.25 6.42999 12.75 8.57999 13.46 10.11L4.41 19.16C4.02 19.55 4.02 20.18 4.41 20.57C4.8 20.96 5.43 20.96 5.82 20.57L12 14.41L18.18 20.59C18.57 20.98 19.2 20.98 19.59 20.59C19.98 20.2 19.98 19.57 19.59 19.18L13.41 13L14.88 11.53Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-local-dining`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconLocalDining

    ```js
    <b-new-b-icon-local-dining />
    ```
</docs>


